__turbopack_context__.v({
  "controlsWrapper": "MediaOverlay-module-scss-module__PVL-Ra__controlsWrapper",
  "gradient": "MediaOverlay-module-scss-module__PVL-Ra__gradient",
  "isHero": "MediaOverlay-module-scss-module__PVL-Ra__isHero",
  "mediaImage": "MediaOverlay-module-scss-module__PVL-Ra__mediaImage",
  "overlay": "MediaOverlay-module-scss-module__PVL-Ra__overlay",
  "playButton": "MediaOverlay-module-scss-module__PVL-Ra__playButton",
});
